<template>
  <ul :class="classes">
    <slot></slot>
    <t-time-item v-if="pending" :title="pending === true ? '' : pending">
      <t-icon slot="dot" :gradient="pendingColor ? pendingColor : 'primary'" type="loading" class="aid-ani-loop" size="20"></t-icon>
    </t-time-item>
  </ul>
</template>
<script>
import TTimeItem from './timeline-item.vue'
import TIcon from '../icon/icon.vue'
const PREFIXCLS = 'timeline'

export default {
  name: 'TTimeLine',
  components: {TTimeItem, TIcon},
  props: {
    pending: {
      type: [Boolean, String],
      default: false
    },
    pendingColor: {
      type: String
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIXCLS}`,
        {
          [`${PREFIXCLS}-pending`]: this.pending,
          [`${PREFIXCLS}--horizontal`]: this.horizontal
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// timeline.vue?47faeb35